jQuery(function(){
  if(!jQuery('body').hasClass('woocommerce-archive')) {
    return
  }

  /*************
  Variables
  */

  /*************
  Function Calls
  */
  jQuery(window).on('load', function() {
    menuSlide()
  })

  function menuSlide() {
    jQuery('.site-content-container.shop-content-container section.widget_nav_menu .menu-item-has-children > a').on('click', function(e) {
      e.preventDefault()
      let $this = jQuery(this)
      $this.parent().addClass('open')
      $this.next('ul.sub-menu').slideToggle()
      $this.off()
    })
  }
})
